import moment from "moment/moment";
import { Guid } from "guid-typescript";

export class GetPickupSlotsQuery {
    private readonly _warehouseCode: string;
    private readonly _departureDate: moment.Moment ;
    private readonly _palletIdsList: Array<{ id: string | Guid }> | undefined;

    constructor(warehouseCode: string, palletIdsList: Array<{ id: string | Guid }>) {
        this._warehouseCode = warehouseCode;
        this._departureDate = moment();
        this._palletIdsList = palletIdsList;
    }

    get warehouseCode(): string {
        return this._warehouseCode;
    }

    get departureDate(): moment.Moment {
        return this._departureDate;
    }

    get palletIdsList() {
        return this._palletIdsList?.map(e => typeof e.id === "string" ? e.id : e.id.toString()) ?? [];
    }
}
